import { Card, CardContent } from "@shared/ui/card";
import { Users, ArrowRight } from "lucide-react";

type SubAccountCardProps = {
  masterAccount: {
    name: string;
    number: string;
    phone: string;
    address: string;
  };
};


export const SubAccountCard = ({
  masterAccount,
}: SubAccountCardProps) => {

  const masterDetails = [
    { key: "name", label: "MASTER ACCOUNT NAME" },
    { key: "number", label: "MASTER ACCOUNT NUMBER" },
    { key: "phone", label: "MASTER ACCOUNT PHONE" },
    { key: "address", label: "MASTER ACCOUNT ADDRESS" },
  ] as const;

  return (
    <Card className="rounded-xl border-2 border-blue-200 bg-blue-50/60 overflow-hidden shadow-sm">
      <CardContent className="p-0">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4">
          <div className="flex items-center gap-3">
            <div className="bg-blue-500 p-2.5 rounded-full flex items-center justify-center">
              <Users className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="font-bold text-blue-900">
                This is a Sub-Account
              </p>
              <p className="text-sm text-blue-700">
                Currently linked under master account {masterAccount.number}
              </p>
            </div>
          </div>

          <span className="text-xs font-bold tracking-wider text-white bg-blue-600 px-4 py-1.5 rounded-full">
            SUB-ACCOUNT
          </span>
        </div>

        {/* Body */}
        <div className="px-5 pb-5 space-y-4">
          {/* Banner */}
          <div className="rounded-md px-4 py-3 text-sm bg-blue-100/70 text-blue-900 border-l-4 border-blue-400">      
             This account is currently a sub-account under a master account. The transfer has been initiated to move ownership at the same premises.
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4 text-sm">
            {masterDetails.map(({ key, label }) => (
              <div key={key}>
                <p className="text-gray-500 text-xs font-semibold tracking-wider">
                  {label}
                </p>
                <p className="font-bold text-gray-900 mt-1">
                  {masterAccount[key]}
                </p>
              </div>
            ))}
          </div>

          {/* Transfer Decision — read-only chip, only when not yet transferred */}
            <div className="flex flex-wrap items-center gap-3 pt-1">
              <p className="font-bold text-blue-900">Transfer Decision:</p>
              <span className="inline-flex items-center gap-1.5 bg-blue-50 text-blue-700 font-semibold text-sm px-3 py-1.5 rounded-full border border-blue-200">
                <ArrowRight className="w-4 h-4" />
                {'Transfer to Master'}
              </span>
            </div>
        </div>
      </CardContent>
    </Card>
  );
};